import React from "react";
import { Outlet } from "react-router-dom";
import AuthLayout from "./AuthLayout";

// Shared layout route for every auth screen (Sign In, Reset Password, Verify OTP,
// etc.). AuthLayout (and its animated HeroTree) mounts ONCE here; the individual
// form pages render through <Outlet/>, so switching auth screens only swaps the
// form card while the hero animation keeps looping (no remount / no re-grow).
const AuthLayoutRoute = () => (
  <AuthLayout>
    <Outlet />
  </AuthLayout>
);

export default AuthLayoutRoute;
